/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type RemoveTeamMemberAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class RemoveTeamMemberAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RemoveTeamMemberAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: RemoveTeamMemberAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RemoveTeamMemberAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type RemoveTeamMemberAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class RemoveTeamMemberAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RemoveTeamMemberAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: RemoveTeamMemberAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RemoveTeamMemberAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type RemoveTeamMemberAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class RemoveTeamMemberAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RemoveTeamMemberAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: RemoveTeamMemberAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RemoveTeamMemberAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type RemoveTeamMemberAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class RemoveTeamMemberAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RemoveTeamMemberAuthTeamsResponseResponseBodyData;

  constructor(
    err: RemoveTeamMemberAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RemoveTeamMemberAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type RemoveTeamMemberAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class RemoveTeamMemberAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RemoveTeamMemberAuthTeamsResponseBodyData;

  constructor(
    err: RemoveTeamMemberAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RemoveTeamMemberAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type RemoveTeamMemberResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class RemoveTeamMemberResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RemoveTeamMemberResponseBodyData;

  constructor(
    err: RemoveTeamMemberResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RemoveTeamMemberResponseBody";
  }
}

/** @internal */
export const RemoveTeamMemberAuthTeamsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RemoveTeamMemberAuthTeamsResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RemoveTeamMemberAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RemoveTeamMemberAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    RemoveTeamMemberAuthTeamsResponse429ResponseBody
  > = z.instanceof(RemoveTeamMemberAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RemoveTeamMemberAuthTeamsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RemoveTeamMemberAuthTeamsResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RemoveTeamMemberAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RemoveTeamMemberAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    RemoveTeamMemberAuthTeamsResponse409ResponseBody
  > = z.instanceof(RemoveTeamMemberAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RemoveTeamMemberAuthTeamsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RemoveTeamMemberAuthTeamsResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RemoveTeamMemberAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RemoveTeamMemberAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    RemoveTeamMemberAuthTeamsResponse404ResponseBody
  > = z.instanceof(RemoveTeamMemberAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RemoveTeamMemberAuthTeamsResponseResponseBody$inboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RemoveTeamMemberAuthTeamsResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type RemoveTeamMemberAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RemoveTeamMemberAuthTeamsResponseResponseBody$outboundSchema:
  z.ZodType<
    RemoveTeamMemberAuthTeamsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    RemoveTeamMemberAuthTeamsResponseResponseBody
  > = z.instanceof(RemoveTeamMemberAuthTeamsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RemoveTeamMemberAuthTeamsResponseBody$inboundSchema: z.ZodType<
  RemoveTeamMemberAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new RemoveTeamMemberAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type RemoveTeamMemberAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RemoveTeamMemberAuthTeamsResponseBody$outboundSchema: z.ZodType<
  RemoveTeamMemberAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  RemoveTeamMemberAuthTeamsResponseBody
> = z.instanceof(RemoveTeamMemberAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const RemoveTeamMemberResponseBody$inboundSchema: z.ZodType<
  RemoveTeamMemberResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new RemoveTeamMemberResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type RemoveTeamMemberResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RemoveTeamMemberResponseBody$outboundSchema: z.ZodType<
  RemoveTeamMemberResponseBody$Outbound,
  z.ZodTypeDef,
  RemoveTeamMemberResponseBody
> = z.instanceof(RemoveTeamMemberResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
